import { useEffect, useRef } from "react";

export default function RiskChart({ risks }) {
  const canvasRef = useRef(null);
  const chartRef  = useRef(null);

  useEffect(() => {
    const tryBuild = () => {
      if (!window.Chart || !canvasRef.current) return;

      if (chartRef.current) { chartRef.current.destroy(); chartRef.current = null; }

      if (!risks.length) return;

      const sorted = [...risks].sort((a, b) => b.score - a.score);

      chartRef.current = new window.Chart(canvasRef.current, {
        type: "bar",
        data: {
          labels: sorted.map((r) => r.name),
          datasets: [
            {
              label: "Score",
              data: sorted.map((r) => r.score),
              backgroundColor: sorted.map((r) =>
                r.score > 15 ? "#f4564e" : r.score > 8 ? "#f5a623" : "#42c97a"
              ),
              borderRadius: 5,
              borderSkipped: false,
            },
            {
              label: "RPN ÷ 10",
              data: sorted.map((r) => Math.round(r.rpn / 10)),
              backgroundColor: "rgba(167,139,250,0.45)",
              borderRadius: 5,
              borderSkipped: false,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: {
              backgroundColor: "#1a1b28",
              titleColor: "#e4e4f0",
              bodyColor: "#9090b0",
              padding: 10,
              cornerRadius: 7,
              callbacks: {
                label: (ctx) => {
                  if (ctx.datasetIndex === 1) return ` RPN: ${ctx.raw * 10}`;
                  return ` Score: ${ctx.raw}`;
                },
              },
            },
          },
          scales: {
            x: {
              grid: { display: false },
              ticks: { color: "#5a5a78", font: { size: 11, family: "Geist Mono" } },
            },
            y: {
              grid: { color: "rgba(255,255,255,0.04)" },
              ticks: { color: "#5a5a78", font: { size: 11, family: "Geist Mono" } },
              beginAtZero: true,
            },
          },
        },
      });
    };

    if (window.Chart) {
      tryBuild();
    } else {
      const interval = setInterval(() => { if (window.Chart) { clearInterval(interval); tryBuild(); } }, 100);
      return () => clearInterval(interval);
    }

    return () => { if (chartRef.current) { chartRef.current.destroy(); chartRef.current = null; } };
  }, [risks]);

  if (!risks.length) {
    return <div className="chart-empty">No risks to chart yet — add some first.</div>;
  }

  return (
    <div className="chart-panel">
      <div className="chart-header">
        <div className="chart-title">Risk Score & RPN by risk (sorted by score)</div>
        <div className="chart-legend">
          <div className="legend-item">
            <div className="legend-sq" style={{ background: "#6c8ef5" }} />Score
          </div>
          <div className="legend-item">
            <div className="legend-sq" style={{ background: "rgba(167,139,250,0.6)" }} />RPN ÷ 10
          </div>
        </div>
      </div>
      <div style={{ position: "relative", width: "100%", height: `${Math.max(280, risks.length * 42 + 60)}px` }}>
        <canvas ref={canvasRef} />
      </div>
    </div>
  );
}